import script from "./MarkdownViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./MarkdownViewer.vue?vue&type=script&setup=true&lang=js"

import "./MarkdownViewer.vue?vue&type=style&index=0&id=3da22bf6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3da22bf6"]])

export default __exports__